import { gql } from '@apollo/client';
export const UPDATE_PROFILE = gql`
	mutation UpdateProfile($ingredientsTemplateId: String, $companyDetails: CompanyDetailsInput) {
		updateProfile(
			updateProfile: {
				ingredientsTemplateId: $ingredientsTemplateId
				companyDetails: $companyDetails
			}
		) {
			ingredientsTemplateId
			favoriteProducts {
				pid
				addDate
			}
			companyDetails {
				userType
				jobType
				website
				name
			}
		}
	}
`;

export const ADD_FAVORITE = gql`
	mutation AddFavorite($productId: String!, $expoEventId: String) {
		addFavoriteProduct(productId: $productId, expoEventId: $expoEventId) {
			favoriteProducts {
				pid
				addDate
			}
		}
	}
`;

export const DELETE_FAVORITE = gql`
	mutation DeleteFavorite($productId: String!, $expoEventId: String) {
		deleteFavoriteProduct(productId: $productId, expoEventId: $expoEventId) {
			favoriteProducts {
				pid
				addDate
			}
		}
	}
`;

export const DELETE_ALL_FAVORITE = gql`
	mutation RemoveAllFavoriteProducts($profileId: String!) {
		removeAllFavoriteProducts(profileId: $profileId)
	}
`;

export const CREATE_PROFILE = gql`
	mutation CreateProfile($ingredientsTemplateId: String!) {
		createProfile(createProfileInput: { ingredientsTemplateId: $ingredientsTemplateId }) {
			ingredientsTemplateId
		}
	}
`;
